import { FilterValue } from 'components/Filter'

export type FilterVariables = {
  terms: FilterValue[]
}

export type MutationInputError = {
  attribute: string
  message: string
}

export type PaginationData = {
  totalCount: number
}

export type PaginationVariables = {
  first: number
  last: number
}

export type SortDirection = 'asc' | 'desc'

export const calculatePagination = ({
  page,
  rowsPerPage,
}: {
  page: number
  rowsPerPage: number
}): PaginationVariables => ({
  first: page * rowsPerPage,
  last: rowsPerPage,
})
